import React, { useState } from "react";
import styles from "../InviteUserAfterMail/UserAccountLinker.module.scss";
import Loader from "../UiComponents/loader/Loader";
import axios from "axios";
import { MdOutlineAssignmentInd } from "react-icons/md";
import { AiOutlineEyeInvisible, AiOutlineEye } from "react-icons/ai";
import { useTranslation } from "react-i18next";

export default function SignUpModal({
  setDisplaySignUpModal,
  setAccountCreate,
  setUserPasswordSignIn,
  confirmInvitation,
  setNameForEmailSuccess,
  setLastNameForEmailSucess,
}) {
  // SECURITE F6 : plus de lecture du token en localStorage. Le cookie
  // httpOnly hs_invite est envoye automatiquement par le navigateur.
  const { t } = useTranslation();

  const [validation, setValidation] = useState("");
  const [name, setName] = useState("");
  const [lastName, setlastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const registered = new Date().toISOString().slice(0, 19).replace("T", " ");
  const status = 1;

  const capitalize = (s) => s && s[0].toUpperCase() + s.slice(1);

  const handleForm = async (e) => {
    e.preventDefault();
    setValidation("");

    const login = `${name}_${lastName}`.toLowerCase();

    // Contrôle avant envoi : tous les champs remplis
    if (!email.trim() || !lastName.trim() || !name.trim() || !password.trim() || !password2.trim()) {
      setValidation(t("validation.fill_all_fields"));
      return;
    }

    if (login.length < 6) {
      setValidation(t("validation.username_min_6_chars"));
      return;
    }

    if (password.length < 8) {
      setValidation(t("validation.password_min_8_chars"));
      return;
    }

    if (password !== password2) {
      setValidation(t("validation.passwords_not_identical"));
      return;
    }

    setLoading(true);
    // Ne pas modifier axios par AXIOS
    // F6 : pas d'header Authorization, le cookie httpOnly hs_invite voyage
    // automatiquement grace a withCredentials.
    axios
      .post(
        `${process.env.REACT_APP_API_URL}api/registerInviteUser/`,
        {
          login,
          name,
          lastName,
          email,
          password,
          password2,
          registered,
          status,
        },
        {
          withCredentials: true,
        }
      )
      .then(function (response) {
        if (response.data.msg === "email already use") {
          setValidation(t("validation.email_already_used"));
          setLoading(false);
          return;
        }
        if (response.data.msg === "login name already use") {
          setValidation(t("validation.username_already_used"));
          setLoading(false);
          return;
        }
        setLoading(false);
        setSuccess(true);
        const userIdCreate = response.data.data;
        confirmInvitation(userIdCreate);

        setTimeout(() => {
          setSuccess(false);
          setDisplaySignUpModal(false);
          setAccountCreate(true);
        }, 2000);
      })
      .catch(function (error) {
        console.log(error);
        setLoading(false);
      });
  };

  return (
    <form onSubmit={handleForm}>
      <div className={styles.formGroup}>
        <input
          className={styles.input}
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        <input
          className={styles.input}
          type="text"
          placeholder={t("common.lastname")}
          value={lastName}
          onChange={(e) => {
            setlastName(capitalize(e.target.value));
            setLastNameForEmailSucess(capitalize(e.target.value));
          }}
          required
        />

        <input
          className={styles.input}
          type="text"
          placeholder={t("common.firstname")}
          value={name}
          onChange={(e) => {
            setName(capitalize(e.target.value));
            setNameForEmailSuccess(capitalize(e.target.value));
          }}
          required
        />

        <div className={styles.inputWrapper}>
          <input
            className={styles.inputPassword}
            type={showPassword ? "text" : "password"}
            placeholder={t("common.password")}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button
            type="button"
            className={styles.passwordToggle}
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? <AiOutlineEye /> : <AiOutlineEyeInvisible />}
          </button>
        </div>

        <div className={styles.inputWrapper}>
          <input
            className={styles.inputPassword}
            type={showPassword2 ? "text" : "password"}
            placeholder={t("common.password_confirm")}
            value={password2}
            onChange={(e) => {
              setPassword2(e.target.value);
              setUserPasswordSignIn(e.target.value);
            }}
            required
          />
          <button
            type="button"
            className={styles.passwordToggle}
            onClick={() => setShowPassword2(!showPassword2)}
          >
            {showPassword2 ? <AiOutlineEye /> : <AiOutlineEyeInvisible />}
          </button>
        </div>

        <p className={styles.passwordHint}>{t("validation.min_8_chars")}</p>

        {validation && <div className={styles.validationError}>{validation}</div>}

        <button type="submit" className={styles.btnSubmit} disabled={loading}>
          <MdOutlineAssignmentInd /> {t("auth.create_account_button")}
        </button>

        {loading && <div className={styles.loader}><Loader /></div>}
        {success && (
          <div style={{ width: "100%", textAlign: "center", color: "#10b981", fontWeight: 600 }}>
            {t("auth.account_registered")}
          </div>
        )}
      </div>
    </form>
  );
}
